module.exports = __webpack_public_path__ + "img/4.05f53d14.jpg";